// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__3aqB1","fadeIn":"About_fadeIn__1EtVg","link":"About_link__3QX5o"};